module.exports = __webpack_public_path__ + "img/icon-check.0f0ac122.svg";